// Member personal-profile fields (synced two-way with the CRM). The Profile
// screen edits these per-member and saves on blur via PATCH
// /users/family-members/:id/profile. The save decision + value normalisation
// live here as pure functions so they can be unit-tested without rendering the
// (heavy) ProfilePage component.

export type MemberProfileField =
  | 'interests'
  | 'favouriteFoodAndDrinks'
  | 'allergies'
  | 'dietaryRequirements';

export const MEMBER_PROFILE_FIELDS: ReadonlyArray<{
  field: MemberProfileField;
  label: string;
  placeholder: string;
}> = [
  { field: 'interests', label: 'Interests', placeholder: 'e.g. football, drawing, dinosaurs (optional)' },
  { field: 'favouriteFoodAndDrinks', label: 'Favourite food & drinks', placeholder: 'e.g. pizza, apple juice (optional)' },
  { field: 'allergies', label: 'Allergies', placeholder: 'e.g. penicillin, bee stings (optional)' },
  { field: 'dietaryRequirements', label: 'Dietary requirements', placeholder: 'e.g. nut allergy, gluten free (optional)' },
];

/** Trim, cap at 500 chars, and collapse an empty/whitespace value to null. */
export function normaliseProfileValue(draft: string | null | undefined): string | null {
  const t = (draft ?? '').trim();
  return t.length ? t.slice(0, 500) : null;
}

/** True when the (trimmed) draft differs from the member's current value. */
export function profileFieldChanged(
  current: string | null | undefined,
  draft: string | null | undefined,
): boolean {
  return (draft ?? '').trim() !== (current ?? '').trim();
}
